import { Alert, AlertTitle, Box, Snackbar } from "@mui/material";
import { useLocation } from "react-router-dom";
import AppRoutes from "../../config/AppRoutes";
import Sidebar from "./Sidebar";
import { useDispatch, useSelector } from "react-redux";
import LoginHeader from "../home/LoginHeader";
import Header from "./Header";
import Footer from "../home/Footer";
import { closeNotificationMessage } from "../../store/AlertSlice";
import { useEffect } from "react";
import { Task } from "@mui/icons-material";
import { TaskCountRepository } from "../repositories/TaskCountRepository";
import { setTaskCounts } from "../../store/TaskCountSlice";

export default function MainLayout() {
  const dispatch = useDispatch();

  const location = useLocation();
  const auth = useSelector((state) => state.auth);
  const alert = useSelector((state) => state.alert);
  const taskCount = useSelector((state) => state.taskCount);

  const hideLayoutPaths = ["/login", "/registration", "/registration/confirm"];
  const shouldShowLayout = !hideLayoutPaths.some((path) =>
    location.pathname.startsWith(path),
  );
  const showSidebar = shouldShowLayout && auth?.userData;

  useEffect(() => {
    if (!auth?.userData) return;

    const fetchData = () => {
      let roles = auth?.userData?.roles;

      if (
        roles?.includes("ROLE_MVR_RECEIVER") ||
        roles?.includes("ROLE_MVR_REVIEWER") ||
        roles?.includes("ROLE_MVR_SIGNER")
      ) {
        TaskCountRepository.fetchInstTaskCounts()
          .then((response) => {
            dispatch(setTaskCounts(response.data));
          })
          .catch((error) => {
            console.error("Error fetching task counts:", error);
          });
      } else if (
        roles?.includes("ROLE_JPDP_RECEIVER") ||
        roles?.includes("ROLE_JPDP_REVIEWER") ||
        roles?.includes("ROLE_JPDP_SIGNER")
      ) {
        TaskCountRepository.fetchInstTaskCounts()
          .then((response) => {
            dispatch(setTaskCounts(response.data));
          })
          .catch((error) => {
            console.error("Error fetching task counts:", error);
          });
      } else if (
        roles?.includes("ROLE_MT_ARCHIVER") ||
        roles?.includes("ROLE_MT_REVIEWER") ||
        roles?.includes("ROLE_MT_SUPERVISOR") ||
        roles?.includes("ROLE_MT_MINISTER") ||
        roles?.includes("ROLE_SUPERADMIN")
      ) {
        // your logic
      }
    };

    // run immediately
    fetchData();

    // run every 5 seconds
    const interval = setInterval(fetchData, 5000);

    // cleanup
    return () => clearInterval(interval);
  }, [auth, dispatch]);

  return (
    <>
      {alert?.open && (
        <Snackbar
          open={alert.open}
          autoHideDuration={6000}
          onClose={() => {
            dispatch(closeNotificationMessage());
          }}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            severity={alert.severity || "info"}
            sx={{ width: "100%" }}
            variant="filled"
          >
            <AlertTitle>{alert.message}</AlertTitle>
          </Alert>
        </Snackbar>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {shouldShowLayout && (
          <>
            <LoginHeader />
            <Header />
          </>
        )}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
            position: "relative",
          }}
        >
          <AppRoutes />
        </Box>
        {shouldShowLayout && <Footer />}
        {showSidebar && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              height: "100vh",
              overflowY: "auto",
            }}
          >
            <Sidebar />
          </Box>
        )}
      </Box>
    </>
  );
}
